'use client'
import React, {useEffect, useState} from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import MenuIcon from '@mui/icons-material/Menu'
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp'
import Grid from '@mui/material/Grid'
import Link from 'next/link'
import Image from 'next/image'
import useTranslation from '../util/translations/useTranslation'
import {
    ROUTE_BLOG,
    ROUTE_CONTACT,
    ROUTE_COURSES,
    ROUTE_DISCORD_INVITE,
    ROUTE_FITNESS,
    ROUTE_HOME,
    ROUTE_MEMBER,
    ROUTE_PRICING,
    ROUTE_STUDIO,
    ROUTE_TEAM,
    ROUTE_TRIAL,
    ROUTE_VISION,
} from '../Routes'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import SideContentAppRouter from './SideContent'
import Button from '@mui/material/Button'
import MenuItem from '@mui/material/MenuItem'
import ListItemText from '@mui/material/ListItemText'
import {Container, createSvgIcon, SvgIcon} from '@mui/material'
import Popper from '@mui/material/Popper'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import MenuList from '@mui/material/MenuList'
import IMAGE_LOGO from '../../public/icons/firstclasslogo_schwarz-colored.png'
import Divider from '@mui/material/Divider'
import useScrollTrigger from '@mui/material/useScrollTrigger'
import Slide from '@mui/material/Slide'
import Close from '@mui/icons-material/Close'

const DiscordIcon = createSvgIcon(
    <path
        d='M60.1045 4.8978C55.5792 2.8214 50.7265 1.2916 45.6527 0.41542C45.5603 0.39851 45.468 0.440769 45.4204 0.525289C44.7963 1.6353 44.105 3.0834 43.6209 4.2216C38.1637 3.4046 32.7345 3.4046 27.3892 4.2216C26.905 3.0581 26.1886 1.6353 25.5617 0.525289C25.5141 0.443589 25.4218 0.40133 25.3294 0.41542C20.2584 1.2888 15.4057 2.8186 10.8776 4.8978C10.8384 4.9147 10.8048 4.9429 10.7825 4.9795C1.57795 18.7309 -0.943561 32.1443 0.293408 45.3914C0.299005 45.4562 0.335386 45.5182 0.385761 45.5576C6.45866 50.0174 12.3413 52.7249 18.1147 54.5195C18.2071 54.5477 18.305 54.5139 18.3638 54.4378C19.7295 52.5728 20.9469 50.6063 21.9907 48.5383C22.0523 48.4172 21.9935 48.2735 21.8676 48.2256C19.9366 47.4931 18.0979 46.6 16.3292 45.5858C16.1893 45.5041 16.1781 45.304 16.3068 45.2082C16.679 44.9293 17.0513 44.6391 17.4067 44.3461C17.471 44.2926 17.5606 44.2813 17.6362 44.3151C29.2558 49.6202 41.8354 49.6202 53.3179 44.3151C53.3935 44.2785 53.4831 44.2898 53.5502 44.3433C53.9057 44.6363 54.2779 44.9293 54.6529 45.2082C54.7816 45.304 54.7732 45.5041 54.6333 45.5858C52.8646 46.6197 51.0259 47.4931 49.0921 48.2228C48.9662 48.2707 48.9102 48.4172 48.9718 48.5383C50.038 50.6034 51.2554 52.5699 52.5959 54.435C52.6519 54.5139 52.7526 54.5477 52.845 54.5195C58.6464 52.7249 64.529 50.0174 70.6019 45.5576C70.6551 45.5182 70.6887 45.459 70.6943 45.3942C72.1747 30.0791 68.2147 16.7757 60.1968 4.9823C60.1772 4.9429 60.1437 4.9147 60.1045 4.8978ZM23.7259 37.3253C20.2276 37.3253 17.3451 34.1136 17.3451 30.1693C17.3451 26.225 20.1717 23.0133 23.7259 23.0133C27.308 23.0133 30.1626 26.2532 30.1066 30.1693C30.1066 34.1136 27.28 37.3253 23.7259 37.3253ZM47.3178 37.3253C43.8196 37.3253 40.9371 34.1136 40.9371 30.1693C40.9371 26.225 43.7636 23.0133 47.3178 23.0133C50.9 23.0133 53.7545 26.2532 53.6986 30.1693C53.6986 34.1136 50.9 37.3253 47.3178 37.3253Z'
        fill='#5865F2' />,
    'Discord',
)

function HideOnScroll(props) {
    const trigger = useScrollTrigger()

    return (
        <Slide appear={false} direction='down' in={!trigger}>
            {props.children}
        </Slide>
    )
}

function Header(props) {
    const {getT} = useTranslation()
    const [state, changeState] = useState({
        isDrawerOpen: false,
    })

    function toggleDrawer() {
        changeState({
            ...state,
            isDrawerOpen: !state.isDrawerOpen,
        })
    }

    const [openAboutUs, setOpenAboutUs] = React.useState(false)
    const [openFitness, setOpenFitness] = React.useState(false)
    const anchorRefAboutUs = React.useRef<HTMLLIElement>(null)
    const anchorRefFitness = React.useRef<HTMLLIElement>(null)

    const handleToggleAboutUs = () => {
        setOpenAboutUs(prevOpenAboutUs => !prevOpenAboutUs)
        setOpenFitness(false)
    }
    const handleToggleFitness = () => {
        setOpenFitness(prevOpenFitness => !prevOpenFitness)
        setOpenAboutUs(false)
    }

    const handleClose = (event: Event) => {
        if ((anchorRefAboutUs.current && anchorRefAboutUs.current.contains(event.target as Node)) ||
            (anchorRefFitness.current && anchorRefFitness.current.contains(event.target as Node))
        ) {
            return
        }

        setOpenAboutUs(false)
        setOpenFitness(false)
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault()
            setOpenAboutUs(false)
            setOpenFitness(false)
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevOpenAboutUs = React.useRef(openAboutUs)
    useEffect(() => {
        if (prevOpenAboutUs.current && !openAboutUs) {
            anchorRefAboutUs.current?.focus()
        }

        prevOpenAboutUs.current = openAboutUs
    }, [openAboutUs])
    const prevOpenFitness = React.useRef(openFitness)
    useEffect(() => {
        if (prevOpenFitness.current && !openFitness) {
            anchorRefFitness.current?.focus()
        }

        prevOpenFitness.current = openFitness
    }, [openFitness])

    return (
        <div className='header'>
            <HideOnScroll {...props}>
                <AppBar color='primary'>
                    <nav>
                        <Toolbar style={{display: 'flex', justifyContent: 'space-between'}}>
                            <div style={{display: 'flex', alignItems: 'center'}}>
                                <div className='mobile__show'>
                                    <IconButton
                                        onClick={toggleDrawer}
                                        edge='start'
                                        color='secondary'
                                        aria-label='menu'
                                        size='large'>
                                        <MenuIcon />
                                        <SwipeableDrawer open={state.isDrawerOpen}
                                                         onOpen={toggleDrawer}
                                                         onClose={toggleDrawer}>
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'flex-end',
                                            }}>
                                                <IconButton onClick={() => setOpenAboutUs(false)} size='large'>
                                                    <Close />
                                                </IconButton>
                                            </div>
                                            <Divider />
                                            <SideContentAppRouter />
                                        </SwipeableDrawer>
                                    </IconButton>
                                </div>
                            </div>

                            {/* Mobile Member Area button - always visible */}
                            <div className='mobile__show'>
                                <Link href={ROUTE_MEMBER} className='header-item'>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        size='small'
                                        startIcon={<AccountCircleSharpIcon />}
                                        style={{
                                            padding: '4px 8px',
                                            minHeight: '32px',
                                            fontSize: '0.75rem',
                                            lineHeight: 1,
                                        }}>
                                        MEMBER AREA
                                    </Button>
                                </Link>
                            </div>

                            <Container disableGutters={true} className='mobile__hide'>
                                <Grid container
                                      spacing={2}
                                      direction='row'
                                      justifyContent='center'
                                      style={{
                                          flexGrow: 1,
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          alignContent: 'center',
                                      }}>
                                    <Grid className='mobile__hide'>
                                        <Link href={ROUTE_HOME} as={ROUTE_HOME} className='header-item'>

                                            <MenuItem style={{borderRadius: '5%'}}>
                                                <Image
                                                    alt='First Class Performance GmbH Logo'
                                                    src={IMAGE_LOGO}
                                                    width='92'
                                                    height='48'
                                                    placeholder='blur'
                                                    style={{
                                                        maxWidth: '100%',
                                                        height: 'auto',
                                                    }} />
                                            </MenuItem>

                                        </Link>
                                    </Grid>
                                    <Grid className='mobile__hide'>
                                        <Link href={ROUTE_BLOG} as={ROUTE_BLOG} className='header-item'>
                                            <MenuItem style={{borderRadius: '5%'}}>
                                                <ListItemText primary='Blog' />
                                            </MenuItem>
                                        </Link>
                                    </Grid>
                                    <Grid className='mobile__hide'>
                                        <Link
                                            href={ROUTE_PRICING}
                                            as={ROUTE_PRICING}
                                            className='header-item'
                                        >
                                            <MenuItem style={{borderRadius: '5%'}}>
                                                <ListItemText primary='Preise' />
                                            </MenuItem>
                                        </Link>
                                    </Grid>
                                    <Grid className='mobile__hide'>
                                        <MenuItem style={{borderRadius: '5%'}}
                                                  ref={anchorRefFitness}
                                                  aria-controls={openFitness ? 'menu-list-grow' : undefined}
                                                  aria-haspopup='true'
                                                  onClick={handleToggleFitness}>
                                            <ListItemText primary='Fitness' />
                                        </MenuItem>
                                        <Popper open={openFitness}
                                                anchorEl={anchorRefFitness.current}
                                                role={undefined}
                                                transition
                                                disablePortal>
                                            {({TransitionProps, placement}) => (
                                                <Grow {...TransitionProps}
                                                      style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}>
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={handleClose}>
                                                            <MenuList autoFocusItem={openFitness} id='menu-list-grow'
                                                                      onKeyDown={handleListKeyDown}>
                                                                <div>
                                                                    <Link href={ROUTE_CONTACT} className='header-item'
                                                                    >
                                                                        <MenuItem style={{width: '100%'}}
                                                                                  onClick={() => setOpenFitness(false)}>
                                                                            Gespräch buchen
                                                                        </MenuItem>
                                                                    </Link>
                                                                    <Divider variant='middle' style={{
                                                                        marginTop: '0.2em',
                                                                        marginBottom: '0.2em',
                                                                    }} />
                                                                    <Link href={ROUTE_FITNESS} className='header-item'
                                                                    >
                                                                        <MenuItem style={{width: '100%'}}
                                                                                  onClick={() => setOpenFitness(false)}>
                                                                            Was ist Fitness?
                                                                        </MenuItem>
                                                                    </Link>
                                                                    <Divider variant='middle' style={{
                                                                        marginTop: '0.2em',
                                                                        marginBottom: '0.2em',
                                                                    }} />
                                                                    <Link href={ROUTE_COURSES} className='header-item'
                                                                    >
                                                                        <MenuItem style={{width: '100%'}}
                                                                                  onClick={() => setOpenFitness(false)}>
                                                                            Kurse
                                                                        </MenuItem>
                                                                    </Link>
                                                                </div>
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </Grid>
                                    <Grid className='mobile__hide'>
                                        <MenuItem style={{borderRadius: '5%'}}
                                                  ref={anchorRefAboutUs}
                                                  aria-controls={openAboutUs ? 'menu-list-grow' : undefined}
                                                  aria-haspopup='true'
                                                  onClick={handleToggleAboutUs}>
                                            <ListItemText primary='Über Uns' />
                                        </MenuItem>
                                        <Popper open={openAboutUs}
                                                anchorEl={anchorRefAboutUs.current}
                                                role={undefined}
                                                transition
                                                disablePortal>
                                            {({TransitionProps, placement}) => (
                                                <Grow {...TransitionProps}
                                                      style={{transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'}}>
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={handleClose}>
                                                            <MenuList autoFocusItem={openAboutUs} id='menu-list-grow'
                                                                      onKeyDown={handleListKeyDown}>
                                                                <div>
                                                                    <Link href={ROUTE_STUDIO} className='header-item'
                                                                    >
                                                                        <MenuItem style={{width: '100%'}}
                                                                                  onClick={() => setOpenAboutUs(false)}>
                                                                            {getT('links.studio.name')}
                                                                        </MenuItem>
                                                                    </Link>
                                                                    <Divider variant='middle' style={{
                                                                        marginTop: '0.2em',
                                                                        marginBottom: '0.2em',
                                                                    }} />
                                                                    <Link href={ROUTE_TEAM} className='header-item'
                                                                    >
                                                                        <MenuItem style={{width: '100%'}}
                                                                                  onClick={() => setOpenAboutUs(false)}>
                                                                            {getT('links.team.name')}
                                                                        </MenuItem>
                                                                    </Link>
                                                                    <Divider variant='middle' style={{
                                                                        marginTop: '0.2em',
                                                                        marginBottom: '0.2em',
                                                                    }} />
                                                                    <Link href={ROUTE_VISION} className='header-item'
                                                                    >
                                                                        <MenuItem style={{width: '100%'}}
                                                                                  onClick={() => setOpenAboutUs(false)}>
                                                                            {getT('links.vision.name')}
                                                                        </MenuItem>
                                                                    </Link>
                                                                </div>
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </Grid>
                                    <Grid className='mobile__hide'>
                                        <Link
                                            href={ROUTE_CONTACT}
                                            as={ROUTE_CONTACT}
                                            className='header-item'
                                        >
                                            <MenuItem style={{borderRadius: '5%'}}>
                                                <ListItemText primary={getT('links.contact.name')} />
                                            </MenuItem>
                                        </Link>
                                    </Grid>

                                    {/* Discord button */}
                                    <Grid className='mobile__hide'>
                                        <a href={ROUTE_DISCORD_INVITE}
                                           target='_blank'
                                           rel='noreferrer'
                                           className='header-item'>
                                            <MenuItem style={{borderRadius: '5%'}}>
                                                <div style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>
                                                    <SvgIcon
                                                        component={DiscordIcon}
                                                        viewBox='0 0 71 55'
                                                        color='secondary'
                                                        fontSize='medium' />
                                                </div>
                                            </MenuItem>
                                        </a>
                                    </Grid>

                                    {/* Gespräch Buchen button */}
                                    <Grid className='mobile__hide' style={{marginLeft: 'auto'}}>
                                        <Link href={ROUTE_TRIAL} className='header-item'>
                                            <Button variant='contained'
                                                    color='secondary'>
                                                GESPRÄCH BUCHEN
                                            </Button>
                                        </Link>
                                    </Grid>

                                    {/* Member Area button for desktop */}
                                    <Grid className='mobile__hide' style={{marginLeft: '10px'}}>
                                        <Link href={ROUTE_MEMBER} className='header-item'>
                                            <Button variant='contained'
                                                    color='secondary'
                                                    startIcon={<AccountCircleSharpIcon />}>
                                                MEMBER AREA
                                            </Button>
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Container>
                        </Toolbar>
                    </nav>
                </AppBar>
            </HideOnScroll>
        </div>
    )
}

export default Header
